import { useMutation, useQuery } from '@tanstack/react-query';

import { queryClient } from '@/config/reactQuery';

import { QUERY_KEYS } from '../../queryKeys';
import { users } from '../Users';
import { UserPermissionModel } from '@/types';

export const useUserPermissions = (enabled: boolean) =>
  useQuery({
    queryKey: [QUERY_KEYS.userPermissions],
    queryFn: async () => {
      const res = await users.getUserPermissions();
      const data: UserPermissionModel = res.data || { loaded: true };
      data.loaded = true;
      return data;
    },
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

export const useUsers = (userId?: number) =>
  useQuery({
    queryKey: [QUERY_KEYS.users, userId],
    queryFn: async () => (await users.getUsers(userId)).data,
  });

export const useUserTypes = () =>
  useQuery({
    queryKey: [QUERY_KEYS.userType],
    queryFn: async () => (await users.getUserTypes()).data,
  });

export const useCreateUser = () =>
  useMutation({
    mutationFn: users.createUser,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.users] }),
  });

export const useUpdateUser = () =>
  useMutation({
    mutationFn: users.updateUser,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.users] }),
  });

export const useDeleteUser = () =>
  useMutation({
    mutationFn: users.deleteUser,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.users] }),
  });

export const useResetPassword = () =>
  useMutation({ mutationFn: users.resetPassword });

export const useResetUserPassword = () =>
  useMutation({ mutationFn: users.resetUserPassword });

export const useLogout = () => useMutation({ mutationFn: users.logout });
